// GDACS list feature -> the event shape the map uses.

const TYPE_BY_CODE = { TC: 'cyclone', FL: 'flood' };

export function mapGdacsEvent(f) {
  const p = f?.properties || {};
  return {
    id: p.eventid || `${p.eventtype}-${Date.now()}`,
    type: TYPE_BY_CODE[p.eventtype] || 'earthquake',
    name: p.eventname || p.name || 'Event',
    location: p.country || null,
    lat: f?.geometry?.coordinates?.[1],
    lng: f?.geometry?.coordinates?.[0],
    severity: p.alertlevel || 'unknown',
    fromDate: p.fromdate,
    toDate: p.todate,
    eventType: p.eventtype,
    urls: {
      geometry: p.url?.geometry || null,
    },
    severityData: {
      value: p.severitydata?.severity ?? null,
      text: p.severitydata?.severitytext || '',
    },
    // GDACS sends the string 'true' / 'false'.
    isCurrent: String(p.iscurrent).toLowerCase() === 'true',
    dateModified: p.datemodified || null,
  };
}

// 'Magnitude 6.3M, Depth:10km' -> { magnitude: 6.3, depthKm: 10 }
export const parseMagnitudeDepth = (text) => {
  const m = /Magnitude\s*([\d.]+)\s*M.*?Depth:\s*([\d.]+)\s*km/i.exec(String(text || ''));
  return m ? { magnitude: Number(m[1]), depthKm: Number(m[2]) } : { magnitude: null, depthKm: null };
};
